<template>
    <div>

        <RouterView></RouterView>
        <vue-internet-checker @status="status"
                              @event="event" />

        <b-overlay :show="networkError" :fixed="true" no-wrap
                   z-index="9999999">
            <template #overlay>
                <h4 class="text-danger font-weight-bold">{{ $t("Oops! it seems you are offline or you connection is really slow")}}</h4>
                <br />
                <span class="text-success font-weight-bold">{{ $t('Attempting to re-connect...') }}</span>
            </template>
        </b-overlay>
        <!--<footer class="site-footer" style="height:50px">© 2021 PManager</footer>-->

    </div>
</template>

<script>

    import Vue from "vue";
    import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';
    import vueInternetChecker from 'vue-internet-checker';

Vue.use(SchedulePlugin);

   
    export default {
        components: {
            vueInternetChecker
        },
        data() {
            return {
                u: '',
                online: true,
                networkError: false,
                connecting: false
            }
        },
        methods: {
            leaving() {
                this.store.dispatch('auth/logOut');
            },
            status(ele) {
                //console.log(ele);
                this.online = ele;
            },
            event(ele) {
                console.log(ele);
            },
            tryToConnect() {
                if (!this.networkError)
                    return;

                this.connecting = true;
                this.axios.get('api/health/reachable')
                    .then(response => {

                    })
                    .catch(err => {
                    })
                    .then(() => { this.connecting = false });

            }
        },
        created() {
            let self = this;
            this.axios.interceptors.response.use((response) => {

                this.networkError = false;
                return response;

            }, function (error) {
                    if (error.message === 'Network Error') {
                        self.networkError = true;
                        console.log("NO CONNECTION");
                        setTimeout(self.tryToConnect,4000);
                    } else {
                        self.networkError = false;
                    }
                return Promise.reject(error.response);
            });
        },
        mounted() {

            this.$events.on('network-error', () => {
            });

            this.$events.on('no-network-error', () => {
            });

            //window.addEventListener('beforeunload', function (event) {
            //    this.leaving();
            //}, false)
        }
    }

</script>

<style>

    @import './assets/css/bootstrap.css';
    @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.min.css';
/*    @import './assets/css/icons.css';
*/@import './assets/css/icons2/icons.css';
    @import '../node_modules/primeicons/primeicons.css';
@import './assets/css//primevue.min.css';
@import './assets/css/ptheme.css';
    /*@import './assets/scss/style.scss';*/
    @import './assets/css/main-ltr.css';
    @import './assets/css/rtl-support.css';
    @import './assets/css/custom.css';

    @import '../node_modules/@syncfusion/ej2-base/styles/material.css';
    @import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
    @import '../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
    @import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
    @import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';
    @import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
    @import '../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
    @import "../node_modules/@syncfusion/ej2-vue-pdfviewer/styles/material.css";


    .top-warning {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index:99999;
    }



    .e-input-group.e-control-wrapper.e-date-wrapper.e-input-error {
        border-color: #dc3545 !important;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f46a6a' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f46a6a' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E") !important;
        background-repeat: no-repeat !important;
        background-position: right calc(0.375em + 0.235rem) center !important;
        background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem) !important;
        padding-right: calc(1.5em + 0.94rem) !important;
    }


    .e-input-group.e-input-focus.e-input-error,
    .e-input-group.e-control-wrapper.e-input-focus.e-input-error {
        box-shadow: 0 0 0 0.15rem rgba(244, 106, 106, 0.25) !important;
        transition: none !important;
    }

    .e-input-group.e-control-wrapper.e-date-wrapper.e-input-success {
        border-color: #28a745 !important;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2334c38f' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") !important;
        background-repeat: no-repeat !important;
        background-position: right calc(0.375em + 0.235rem) center !important;
        background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem) !important;
        padding-right: calc(1.5em + 0.94rem) !important;
    }


</style>